import { updateOrCreateResource } from "infrastructure/api";
import { useSimpleRequest } from "hooks";
import { ApiRoutes } from "consts/enpoints/api";
import { BooleanSwitchValue } from "consts/general";
import { UiDateTimeFormatter } from "util/formaters";
import { convertToBooleanSwitch } from "util/transformers";
import useUser from "features/auth/useUser";
import { HighRiskMerchant as HighRiskMerchantType, WithUser } from "features/ecommerce/types";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import useShareholderFileUpload from "./useShareholderFileUpload";

export const useUpdateOrCreateShareholders = () => {
    const { user } = useUser();

    const request = useSimpleRequest();

    const { handleShareholderFileUpload } = useShareholderFileUpload();

    const handleUpdateOrCreateShareholders = (shareholders: Array<HighRiskMerchant.DirectorsAndShareholders.Shareholder>) => (
        Promise.all(
            shareholders.map(shareholder => {
                const {
                    pki,
                    name,
                    addressLine1,
                    city,
                    postalCode,
                    countryOrigin,
                    dateOfBirth,
                    title,
                    email,
                    phone,
                    isPep,
                    sharesPercentage
                } = shareholder;

                return request<HighRiskMerchantType.Shareholder>(() => updateOrCreateResource<WithUser & HighRiskMerchantType.Shareholder>({
                    getRoute: () => ApiRoutes.PutOnboardingsHighRiskShareholderIdentities(user.coreId, pki),
                    getId: () => pki,
                    body: {
                        userId: user.coreId,
                        name,
                        addressLine1,
                        city,
                        postalCode,
                        title,
                        email,
                        phone,
                        countryOrigin: countryOrigin?.[0],
                        dateOfBirth: dateOfBirth?.format(UiDateTimeFormatter.Ui),
                        isPep: convertToBooleanSwitch(isPep),
                        sharesPercentage: Number(sharesPercentage),
                        requestedChangeFields: null,
                        isIncomplete: BooleanSwitchValue.Off
                    }
                }), {
                    onError: response => {
                        throw response;
                    },
                    onSuccess: handleShareholderFileUpload(shareholder)
                })
            })
        )
    );

    return {
        handleUpdateOrCreateShareholders
    };
};

export default useUpdateOrCreateShareholders;
